export interface TimeInputProps {
  onSelectTime?: (hour: number, minute: number, isAmPmToggle: boolean, isFromDropdown: boolean) => void;
  dropdownID: string;
  shouldDisplayIcon?: boolean;
  defaultSelectedDateTime?: Date;
  onTimeInputFocusCallback?: () => void;
  onTimeInputBlurCallback?: (hour: number, minute: number) => void;
  isInErrorState?: boolean;
  onClickSelector?: () => void;
}

export enum DayNightSelector {
  AM = 'AM',
  PM = 'PM',
}
